import { atom } from 'recoil';
import BeaconFilterItem from '../models/BeaconFilterItem';

const stateFilterDisease = atom({
  key: 'filter.disease',
  default: null as BeaconFilterItem | null,
});

export default stateFilterDisease;
